/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductCompanyRequestDtoDto } from '../models/pom-product-company-request-dto-dto';
import { PomProductCompanyResponseDtoDto } from '../models/pom-product-company-response-dto-dto';


/**
 * the Product company codes API
 */
@Injectable({
  providedIn: 'root',
})
export class ProductCompanyCodesService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation companyCodes
   */
  static readonly CompanyCodesPath = '/product/companyCodes';

  /**
   * Get product company codes with relation to productId and list of benefits
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyCodes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyCodes$Response(params: {
    body: PomProductCompanyRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomProductCompanyResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductCompanyCodesService.CompanyCodesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomProductCompanyResponseDtoDto>;
      })
    );
  }

  /**
   * Get product company codes with relation to productId and list of benefits
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyCodes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyCodes(params: {
    body: PomProductCompanyRequestDtoDto
  },
  context?: HttpContext

): Observable<PomProductCompanyResponseDtoDto> {

    return this.companyCodes$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomProductCompanyResponseDtoDto>) => r.body as PomProductCompanyResponseDtoDto)
    );
  }

}
